import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSignupSport } from '../../redux/slices/signupSlice';
import styles from './SportSelect.module.css';
import { sportsOptions } from './sportsOptions';
import Dropdown from '../Dropdown/Dropdown';
import BackButton from '../BackButton/BackButton';

const SportSelect = () => {
  const [selectedSport, setSelectedSport] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = searchParams.get('role'); // selected role from the URL

  const handleContinue = () => {
    if (selectedSport) {
      navigate(`/signup/enter-credentials?role=${role}&sport=${selectedSport}`);
    }
  };

  return (
    <div className={styles.wrapper}>
      <BackButton />
      <h2 className={styles.heading}>Select Your Sport</h2>
      <Dropdown
        options={sportsOptions.map((option) => ({
          ...option,
          label: option.isComingSoon ? `${option.label} (Coming Soon)` : option.label,
          disabled: option.isComingSoon // Add a disabled flag for use in logic
        }))}
        value={selectedSport}
        onChange={(val) => {
          const selected = sportsOptions.find((opt) => opt.value === val);
          if (!selected?.isComingSoon) {
            setSelectedSport(val);
            dispatch(setSignupSport(val));
          }
        }}
        placeholder="Choose a sport..."
      />
      <button
        className={`${styles.continueBtn} ${!selectedSport ? styles.disabled : ''}`}
        onClick={handleContinue}
        disabled={!selectedSport}
      >
        Continue
      </button>
    </div>
  );
};

export default SportSelect;